import type { ChangelogBlock } from '../../lib/changelog'

export function BlockView({ block }: { block: ChangelogBlock }) {
  if (block.kind === 'heading') {
    return (
      <h4 className="text-xs font-semibold uppercase tracking-wide text-blue-600 dark:text-blue-400">
        {block.text}
      </h4>
    )
  }
  if (block.kind === 'list') {
    return (
      <ul className="space-y-1.5 text-sm text-gray-700 dark:text-gray-300">
        {block.items.map((item, idx) => (
          <li key={idx} className="flex gap-2.5">
            <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-gray-400 dark:bg-gray-500" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    )
  }
  return (
    <p className="text-sm text-gray-600 dark:text-gray-400">{block.text}</p>
  )
}
